import { RootStateType } from '@Store';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

interface PropsType {
  shipperCountry?: string;
  organizationName?: string;
}

export function usePickupDropoffAccess({ shipperCountry, organizationName }: PropsType) {
  const pincodeServiceabilityForShipment = useSelector(
    (state: RootStateType) => state?.pincode.pincodeServiceabilityForShipment,
  );
  const orgCountry = useSelector((state: RootStateType) => state.orgSetup?.organizationData?._country?.name);

  const disablePickup: boolean | null = useMemo(() => {
    if (organizationName === 'Cargo Solutions Network') return true;

    return pincodeServiceabilityForShipment
      ? pincodeServiceabilityForShipment?.isPickupServiceable === false
        ? true
        : false
      : pincodeServiceabilityForShipment === null && orgCountry !== shipperCountry
      ? false
      : true;
  }, [pincodeServiceabilityForShipment, shipperCountry, organizationName]);

  const disableDropoff: boolean = useMemo(() => {
    if (organizationName === 'Cargo Solutions Network') return false;

    return shipperCountry !== orgCountry;
  }, [shipperCountry, organizationName]);

  return { disablePickup, disableDropoff };
}
